module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Имя")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue.last_name),
      expression: "innerValue.last_name"
    }],
    class: [{
      'is-danger': _vm.validateErrors.last_name
    }, 'input'],
    attrs: {
      "type": "text",
      "placeholder": "Введите вашу фамилию"
    },
    domProps: {
      "value": (_vm.innerValue.last_name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue.last_name = $event.target.value
      }, _vm.handleChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('icon', {
    staticClass: "el-icon-fa",
    attrs: {
      "name": "user",
      "scale": "1"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue.first_name),
      expression: "innerValue.first_name"
    }],
    class: [{
      'is-danger': _vm.validateErrors.first_name
    }, 'input'],
    attrs: {
      "type": "text",
      "placeholder": "Введите ваше имя"
    },
    domProps: {
      "value": (_vm.innerValue.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue.first_name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('icon', {
    staticClass: "el-icon-fa",
    attrs: {
      "name": "user",
      "scale": "1"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue.middle_name),
      expression: "innerValue.middle_name"
    }],
    class: [{
      'is-danger': _vm.validateErrors.middle_name
    }, 'input'],
    attrs: {
      "type": "text",
      "placeholder": "Введите ваше отчество"
    },
    domProps: {
      "value": (_vm.innerValue.middle_name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue.middle_name = $event.target.value
      }, _vm.handleChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('icon', {
    staticClass: "el-icon-fa",
    attrs: {
      "name": "user",
      "scale": "1"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue.email),
      expression: "innerValue.email"
    }],
    class: [{
      'is-danger': _vm.validateErrors.email
    }, 'input'],
    attrs: {
      "type": "text",
      "placeholder": "Почтовый ящик необходим для связи с вами"
    },
    domProps: {
      "value": (_vm.innerValue.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue.email = $event.target.value
      }, _vm.handleChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('icon', {
    staticClass: "el-icon-fa",
    attrs: {
      "name": "envelope",
      "scale": "1"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('div', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue.phone),
      expression: "innerValue.phone"
    }],
    class: [{
      'is-danger': _vm.validateErrors.phone
    }, 'input'],
    attrs: {
      "type": "text",
      "placeholder": "Телефон необходим для более оперативной связи с вами"
    },
    domProps: {
      "value": (_vm.innerValue.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue.phone = $event.target.value
      }, _vm.handleChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('icon', {
    staticClass: "el-icon-fa",
    attrs: {
      "name": "phone",
      "scale": "1"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221d8812"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/order/CustomerStep.vue
// module id = 611
// module chunks = 2